import { transformBrandToLeanBrand } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/adapters";
import { ILeanProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
export var ILeanProductWithBrandTile;
(function(ILeanProductWithBrandTile) {
    ILeanProductWithBrandTile.fromProductWithBrandTile = function(productWithBrandTile, strictLocalize) {
        var _productWithBrandTile_brand;
        return {
            product: ILeanProductTile.from(productWithBrandTile.product, strictLocalize, productWithBrandTile.brand, undefined, productWithBrandTile.promo_string),
            brand: transformBrandToLeanBrand((_productWithBrandTile_brand = productWithBrandTile.brand) !== null && _productWithBrandTile_brand !== void 0 ? _productWithBrandTile_brand : IBrand.build())
        };
    };
    ILeanProductWithBrandTile.fromLayoutElementData = function(layoutElementData, strictLocalize) {
        var leanTile = layoutElementData.lean_product_with_brand_tile, nonLeanTile = layoutElementData.product_with_brand_tile, leanProductTile = layoutElementData.lean_product_tile;
        if (leanProductTile) {
            return {
                product: leanProductTile,
                brand: undefined
            };
        }
        if (leanTile) {
            return leanTile;
        }
        if (nonLeanTile) {
            return ILeanProductWithBrandTile.fromProductWithBrandTile(nonLeanTile, strictLocalize);
        }
        return undefined;
    };
})(ILeanProductWithBrandTile || (ILeanProductWithBrandTile = {}));
